var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",staticStyle:{"background":"#F6F7FB","border":"none"}},[_c('div',{staticClass:"w-100 clearfix",staticStyle:{"background":"transparent"}},[_c('span',{staticStyle:{"color":"#BDBDBD","font-size":".7rem"}},[_vm._v("Copyright © "+_vm._s(_vm.annee)+" By Flysoft engineering | All Rights Reserved.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }